export class ResponseError extends Error {
  public readonly response: Response;

  constructor(
    message: string,
    responseError: {cause: unknown; response: Response}
  ) {
    super(message);
    this.cause = responseError.cause;
    this.response = responseError.response;
  }

  public isStatusCode(statusCode: number): boolean {
    return this.response.status === statusCode;
  }
}

export const isResponseError = (error: unknown): error is ResponseError =>
  error instanceof ResponseError;
